import React, { useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import FortuneBasketCard from '../components/UI/FortuneBasketCard'
import RelatedProductsSection from '../components/UI/RelatedProductsSection'
import { useWishlist } from '../context/WishlistContext'

export default function WishlistPage() {
  const { items, isSyncing, isAuthenticated } = useWishlist()

  const excludeIds = useMemo(
    () => items.map((item) => item.product?.product_id).filter(Boolean),
    [items]
  )

  if (!isAuthenticated) {
    return (
      <section className="space-top">
        <div className="container py-5">
          <div className="text-center mb-5">
            <h2 className="text-lora font-semibold mb-3">Wishlist</h2>
            <p className="light-color mb-4">
              Please log in to view and manage your saved products.
            </p>
            <NavLink
              to="/login"
              state={{ from: '/wishlist' }}
              className="first-btn d-inline-block"
              style={{ width: 'auto', padding: '14px 28px' }}
            >
              Login
            </NavLink>
          </div>
          <RelatedProductsSection />
        </div>
      </section>
    )
  }

  if (isSyncing && items.length === 0) {
    return (
      <section className="space-top">
        <div className="container py-5">
          <div className="text-center mb-5">
            <h2 className="text-lora font-semibold mb-3">Wishlist</h2>
            <p className="light-color">Loading your wishlist...</p>
          </div>
          <RelatedProductsSection />
        </div>
      </section>
    )
  }

  if (items.length === 0) {
    return (
      <section className="space-top">
        <div className="container py-5">
          <div className="text-center mb-5">
            <h2 className="text-lora font-semibold mb-3">Wishlist</h2>
            <p className="light-color mb-4">
              Your wishlist is empty. Save remedies and products to find them
              here.
            </p>
            <NavLink
              to="/shop"
              className="first-btn d-inline-block"
              style={{ width: 'auto', padding: '14px 28px' }}
            >
              Browse Shop
            </NavLink>
          </div>
          <RelatedProductsSection />
        </div>
      </section>
    )
  }

  return (
    <section className="space-top">
      <div className="container py-5">
        <div className="d-flex justify-content-between align-items-end mb-4 flex-wrap gap-2">
          <div>
            <h2 className="text-lora font-semibold mb-1">Wishlist</h2>
            <p className="light-color mb-0">
              {items.length} saved {items.length === 1 ? 'item' : 'items'}
            </p>
          </div>
          <NavLink
            to="/shop"
            className="text-[#CDA202] no-underline fw-semibold"
          >
            Continue shopping →
          </NavLink>
        </div>

        <div className="row g-3">
          {items.map(({ product, wishlistId }) => (
            <div
              key={wishlistId || product.product_id}
              className="col-12 col-sm-6 col-md-4 col-lg-3"
            >
              <FortuneBasketCard item={product} />
            </div>
          ))}
        </div>

        <RelatedProductsSection excludeIds={excludeIds} />
      </div>
    </section>
  )
}
